import React from "react";
import "../StyleSheets/StyleSheetPages.css"; // Updated CSS file name

function whyus() {
  return (
    <div className="stylesheetpage-container">
      <div className="stylesheetpage-box">
        <h2 className="stylesheetpage-title">
          WHAT SETS ACE INTERNATIONAL ACADEMY APART
        </h2>

        <p className="stylesheetpage-text">
          There are many things which mark ACE International Academy different
          from the other schools in Islamabad and Rawalpindi. The Academy has
          state of the art facilities such as three fully equipped science labs,
          two modern ICT labs and audio/visual Smart Boards in the classrooms. A
          qualified in-house student counselor is available for approach by
          parents and students. Our sport facilities are second to none
          including an indoor, heated swimming pool, a basket ball court, fully
          equipped gym and a functional football ground. The Academy provides
          fresh hot meals daily in the campus cafeteria.
        </p>
        <p className="stylesheetpage-text">
          ACE offers a curriculum based on the guidelines of the Cambridge
          International Examination (CIE) Lower Primary and Primary Syllabus.
          Our teachers receive continuous training from Cambridge qualified
          programmes. ACE is a certified Examination Centre for CIE (PK051).
        </p>
        <p className="stylesheetpage-text">
          All staff frequently takes part in First Aid and Rescue programmes
          conducted by Rescue 1122.
        </p>
        <p className="stylesheetpage-text">
          In our Primary Section, we do not rely on one book for each subject;
          rather teachers have access to a wide range of resource material from
          which they select the most appropriate work the students in their
          class. The main emphasis of education in our Primary Section is to
          start developing critical thinkers who are able to solve problems for
          themselves with the guidance of their class teachers.
        </p>
        <p className="stylesheetpage-text">
          In our Secondary Section, the students move towards what may be seen
          as more formalised learning where there will be course books. However,
          we aim to makes lessons in the Secondary Section as interactive and
          inquiry based as possible.
        </p>
      </div>
    </div>
  );
}

export default whyus;
